import { j as t } from "../../../jsx-runtime-B6kdoens.js";
import { c as d } from "../../../index-CROKJrb5.js";
import { c as x, f as A } from "../../../create-component-CBAeEoQ6.js";
import { u as M } from "../../../NavigationState-EOPjgMu1.js";
import { M as v } from "../../../motion-jk0ivqSc.js";
import { A as C } from "../../../index-LYq8AemS.js";
import { m as b } from "../../../motion-minimal-Crg_qVxv.js";
import { u as a, b as g } from "../../../react-B_GApDuV.js";
const j = d({
  base: "cur-fixed cur-h-full cur-w-full cur-overflow-auto cur-z-5 cur-left-0 cur-bg-surface-neutral cur-p-4 cur-flex cur-flex-col cur-gap-4",
  variants: {
    isBreakpointCollapsed: {
      true: "cur-pt-[5.25rem]",
      false: "cur-pt-[6.5rem]"
    }
  }
}), N = {
  initial: { opacity: 0, translateY: "-100%" },
  animate: {
    opacity: 1,
    translateY: "0%"
  },
  exit: {
    opacity: 0,
    translateY: "-100%",
    transition: {
      duration: 0.25,
      delay: 0.1
    }
  },
  transition: { ease: "easeInOut" }
}, z = x(
  "NavigationMobileMenu",
  A(
    ({ children: o, className: r, closeRef: e, ...s }, i) => {
      const {
        isCollapsedAtom: n,
        isBreakpointCollapsedAtom: l,
        isMobileMenuOpenAtom: u
      } = M(), c = a(n), m = a(l), [p, f] = g(u);
      return e && (e.current = () => {
        f(!1);
      }), /* @__PURE__ */ t.jsx(v, { children: /* @__PURE__ */ t.jsx(C, { children: c && p ? /* @__PURE__ */ t.jsx(
        b.nav,
        {
          className: j({
            className: r,
            isBreakpointCollapsed: m
          }),
          ref: i,
          ...s,
          ...N,
          children: o
        }
      ) : null }) });
    }
  )
);
export {
  z as NavigationMobileMenu
};
//# sourceMappingURL=index.js.map
